import { useState } from "react";
import Table, { localCustomStyles } from "../../../../components/tables/Table";
import { PERMISSIONS } from "../../../PermissionsConstants";
import SaveButton from "../../../../components/SaveButton";
import { useRecoilState, useRecoilValue } from "recoil";
import { leEditMassUpload, leMassUploadData } from "../atom/atom";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import useSaveMassUpload from "../hooks/useSaveMassUpload";
import { toast } from "../../../../components/toastNotification";
import { useQueryClient } from "react-query";
export const MassUploadTable = ({
  data,
  columns,
  onSelectedRowsChange,
  selectedRows,
  setOpenModal,
  setIsBulkSelected,
  clearSelectedRows,
  setMassUploadModal,
  handleReset,
}) => {
  const queryClient = useQueryClient();
  const allMassUploadData = useRecoilValue(leMassUploadData);
  const massUploadData = useRecoilValue(leMassUploadData);
  const [, setMassUploadData] = useRecoilState(leMassUploadData);
  const isEditState = useRecoilValue(leEditMassUpload);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [uploading, setUploading] = useState(false);
  const { mutateAsync: uploadValidData } = useSaveMassUpload();
  const validMassUpload = allMassUploadData;
  const handleSave = () => {
    setOpenConfirm(false);
    setUploading(true);
    uploadValidData(validMassUpload, {
      onSuccess: (res) => {
        setUploading(false);
        if (res) {
          if (res.status === 200) {
            setMassUploadData(
              allMassUploadData.filter((x) => x.condition !== "Valid")
            );
            queryClient.invalidateQueries(["GetLeasedEquipment"]);
            toast.fire(
              "Success",
              "All valid Leased Equipment was uploaded successfully",
              "success"
            );
            setOpenModal(false);
            setMassUploadModal(false);
            handleReset(handleReset);
          } else {
            toast.fire(
              "Adding New Leased Equipment Failed",
              "Server Error: Cannot add new Agreement",
              "error"
            );
          }
        }
      },
      onError: (err) => {
        setUploading(false);
        toast.fire("Adding new Leased Equipment Failed", err, "error");
      },
    });
  };

  const hasValidData = massUploadData?.some((el) => el.condition === "Valid");

  return (
    <div className="-mx-10 px-5">
      {hasValidData && (
        <div className="pb-2 mb-6 mx-8 -mt-6 flex justify-end">
          <SaveButton
            onClick={() => {
              setOpenConfirm(true);
            }}
            disabled={isEditState}
            buttonValue={uploading ? "Saving..." : "Save"}
          />
        </div>
      )}

      <div className="px-6 ">
        <Table
          columns={columns}
          data={massUploadData}
          customStyles={{
            ...localCustomStyles,
            table: {
              style: {
                overflowY: "auto",
                overflowX: "hidden",
                maxHeight: "300px",
              },
            },
          }}
          pagination={!isEditState}
          selectableRows={massUploadData?.length > 0 ? true : false}
          onSelectedRowsChange={onSelectedRowsChange}
          selectedRows={selectedRows}
          setOpenModal={setOpenModal}
          setIsBulkSelected={setIsBulkSelected}
          clearSelectedRows={clearSelectedRows}
        />
      </div>

      <ConfirmBoxModal
        ModalTitle={"Mass Upload Leased Equipment"}
        qConfirmation={`Are you sure you want to save these data?`}
        isOpen={openConfirm}
        onClose={() => setOpenConfirm(false)}
        onClickFunction={() => {
          handleSave();
        }}
      />
    </div>
  );
};
